import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { AuthorId } from '../entities/article';
import { IncomingAuthorResult } from '../ingest';
import { ArticleEnvironment } from '../environment';

export class AuthorRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).url, session, { 'x-device-key': true });
  }

  getAuthor = (authorId: AuthorId): SafePromise<IncomingAuthorResult> => {
    const url = this.URL(`services/misc/author/${authorId}`, {
      key: this.session.getEnvironment(ArticleEnvironment).key,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getAuthorByPath = (path: string): SafePromise<IncomingAuthorResult> => {
    const url = this.URL(`services/misc/authorbypath/${path}`, {
      key: this.session.getEnvironment(ArticleEnvironment).key,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
